import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PageHeader, Loading, Empty, PhaseBadge } from "@/components/common";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

const TITLES = { evidence: ["Preuves", "Evidence"], findings: ["Constats & risques", "Findings & risks"], documentary: ["Contrôles documentaires", "Documentary checks"], actions: ["Plan d'action & Gantt", "Action plan & Gantt"] };

export default function ModulePicker() {
  const { module } = useParams();
  const { tx, lbl } = useI18n();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/audits").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <PageHeader eyebrow={tx("Choisir une mission", "Choose a mission")} title={lbl(TITLES, module)}
        subtitle={tx("Les preuves et constats sont rattachés à un audit précis.", "Evidence and findings belong to a specific audit.")} />
      {!rows ? <Loading /> : rows.length === 0 ? <div className="card-surface"><Empty text={tx("Aucun audit autorisé", "No authorised audits")} /></div> : (
        <div className="grid md:grid-cols-2 gap-4">{rows.map((a) => (
          <Link key={a.id} to={`/audits/${a.id}?tab=${module}`} data-testid={`module-audit-${a.id}`} className="card-surface p-4 hover:border-[#2176AE] transition-colors">
            <div className="text-xs text-slate-500">{a.organization_name}</div>
            <div className="font-display font-semibold text-[#153A63]">{a.title}</div>
            <div className="mt-2"><PhaseBadge phase={a.phase} /></div>
          </Link>))}
        </div>
      )}
    </div>
  );
}
